"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplexGateway = void 0;
const Constants_1 = require("../Constants");
const Gateway_1 = require("./Gateway");
/**
 * Describes a ComplexGateway.
 *
 * Currently not supported.
 */
class ComplexGateway extends Gateway_1.Gateway {
    get bpmnType() {
        return Constants_1.BpmnType.complexGateway;
    }
}
exports.ComplexGateway = ComplexGateway;
//# sourceMappingURL=ComplexGateway.js.map